import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { useOutsideAlerter } from '../../utils';
import useDebounce from '../../utils/useDebounce';
import { formatMoney } from '../../actions';
import { api } from '../../config';

const SearchProducts = forwardRef(({ data, searchAction, cartCallback, initialItems = [], onInitialItemsApplied }, ref) => {

  const [displayValue, setDisplayValue] = useState('');
  const debounceChange = useDebounce(searchAction, 500);

  const [searching, setSearching] = useState(false);
  const [dataSelected, setDataSelected] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (initialItems?.length > 0 && onInitialItemsApplied) {
      setItems(initialItems);
      cartCallback(initialItems);
      onInitialItemsApplied();
    }
  }, [initialItems, onInitialItemsApplied, cartCallback]);

  useImperativeHandle(ref, () => ({
    addProduct: (product, customPrice = null) => {
      const _product = {
        _id: product._id,
        title: product.titulo || product.title,
        price: customPrice != null ? customPrice : (product.preco ?? product.price),
        picture: product.fotos?.[0] ?? product.picture,
        quantity: 1
      };
      setItems(prev => {
        const newItems = [...prev, _product];
        cartCallback(newItems);
        return newItems;
      });
    },
    clearItems: () => {
      setItems([]);
      cartCallback([]);
    }
  }), [cartCallback]);
  
  const closeSearch = () => {
    if(dataSelected && items) {
      setSearching(false)
      setDataSelected(false)
      return
    }
    setSearching(false)
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => closeSearch());

  function handleChange(e) {
    !searching && setSearching(true)
    setDisplayValue(e.target.value)
    debounceChange(e.target.value)
    return
  }

  const selectData = async (stateItems, product) => {
    setDisplayValue(``)
    setDataSelected(true)
    setSearching(false)
    
    var _product = {
      _id: product._id,
      title: product.titulo,
      price: product.preco,
      picture: product.fotos[0],
      quantity: 1
    }

    const newArray = [...stateItems, _product]
    
    setItems(newArray)
    cartCallback(newArray)
  }

  const removeItem = async (itemIdx) => {
    setDisplayValue(``)
    setDataSelected(true)
    setSearching(false)

    let newState = items.filter((_, idx) => idx !== itemIdx);
    
    setItems(newState)
    cartCallback(newState)
  }

  const updateItemPrice = (itemIdx, value) => {
    const num = parseFloat(String(value).replace(',', '.')) || 0;
    const newItems = items.map((it, i) => i === itemIdx ? { ...it, price: num } : it);
    setItems(newItems);
    cartCallback(newItems);
  }

  return (
    <div ref={wrapperRef} className={`inputSearchProducts${ dataSelected ? ' selected' : ''}`} onClick={() => items && setDataSelected(false)}>
      { dataSelected && (<h3>Produtos</h3>) }

      { items && (
        <div className="product-items">
          { items.map((item, idx) => (
            <div className="item" key={idx}>
              <span className="quantity">{item.quantity}</span>
              <div className="image">
                { item.picture && (
                  <img src={`${api}/public/images/${item.picture}`} />
                ) }
              </div>
              <span className="item-title">{item.title}</span>
              <div className="item-price-input">
                <span>R$</span>
                <input
                  type="text"
                  value={item.price ? Number(item.price).toFixed(2).replace('.', ',') : '0,00'}
                  onChange={(e) => updateItemPrice(idx, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <button className="remove" onClick={() => removeItem(idx)}>
                <span></span>
                <span></span>
              </button>
            </div>
          )) }
        </div>
      ) }

      <input name="products" autoComplete="new-password" placeholder="Adicionar Produto(s)" value={displayValue} onChange={handleChange} onClick={() => !searching && setSearching(true)} />
      
      { (data && searching) && (
        <div className="result-search">
          {/*{console.log("Reset Button", data.docs)}*/}
          { data.docs.length > 0 && data.docs.map((item, idx) => (
            <div key={idx} className="item" onClick={() => selectData(items, item)}>
              {item.titulo} - {formatMoney(item.preco)}
            </div>
          )) }
        </div>
      ) }

    </div>
  )
});

SearchProducts.displayName = 'SearchProducts';

export default SearchProducts;